<template>
  <div id="attended-events">
    <div class="activation-block">
      <div class="info-card">
        <div class="info-left">
          <div class="info-icon">
            <i class="fas fa-key"></i>
          </div>

          <div class="info-header-text">
            <div class="info-title">
              <p>{{ $t("home.activate") }}</p>
            </div>
            <div class="info-info">
              <span>{{ $t("home.activateInfo1") }}</span>
              <span style="display:block; color:#ff6565;" v-if="getResponse.validationErrors.some(k => k.key == 'activationCode')"> {{ getResponse.validationErrors.find(k => k.key == "activationCode").value }} </span>
            </div>
          </div>
        </div>

        <div class="info-right">
          <div class="activation-bar">
            <the-mask placeholder="######-#######" :mask="['######-#######']" v-model="activationCode" />
            <md-button :disabled="activateLoading" class="md-primary md-raised" @click="$store.dispatch('activateEvent', { activationCode: activationCode })"> <i v-if="getLoading == 'activation'" class="fa fa-spinner spin"></i> {{ $t("do_activate") }}</md-button>
          </div>
        </div>
      </div>
    </div>

    <div class="attended-events-container">
      <EventBlock :data="events" />
    </div>

    <infinite-loading :infinite-scroll-listen-for-event="true" @infinite="getActivatedEvents" spinner="waveDots">
      <div slot="no-more"></div>
      <NoData slot="no-results" :title="$t('nodatakeys.homeactivatedevents.nodatatitle')" :description="$t('nodatakeys.homeactivatedevents.nodatadesc')" anim="holacon-calender-lottie-v2-without-background" :loading="loading" :button="$t('nodatakeys.homeactivatedevents.nodatabutton')" @btnClick="getActivatedEvents" />
    </infinite-loading>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="getResponse.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ getResponse.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import InfiniteLoading from "vue-infinite-loading";
import NoData from "@/modules/NoData";
import EventBlock from "@/modules/EventBlock";

export default {
  name: "AttendedEvents",
  components: {
    EventBlock,
    InfiniteLoading,
    NoData
  },
  data() {
    return {
      events: [],
      searchTerm: null,
      loading: false,
      moment,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      activateModal: false,
      activationCode: "",
      activateLoading: false,
      response: {
        message: null,
        validationErrors: [],
        hasError: false
      }
    };
  },
  beforeMount() {
    if (this.$route.query.activationCode != undefined && this.$route.query.activationCode != null) {
      this.activationCode = this.$route.query.activationCode;
      this.$store.dispatch("activateEvent", { activationCode: this.activationCode });
    }
  },
  mounted() {},

  computed: {
    getResponse() {
      return this.$store.getters.getResponse;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    }
  },

  methods: {
    async getActivatedEvents($state, reset) {
      var res = await axios.post("/Explore/SearchEvent", { skip: reset ? 0 : this.events.length, take: 10, searchType: 0, searchTerm: this.searchTerm });
      if (res.data.hasError) {
        this.snackbar = { show: true, message: res.data.message };
      } else {
        if (reset) {
          this.events = res.data.data.items;
        } else {
          this.events = [...this.events, ...res.data.data.items];
        }
      }
      try {
        if (res.data.data.items.length == 0) $state.complete();
        else $state.loaded();
      } catch (err) {}
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
#attended-events {
  background-color: transparent;

  .activation-block {
    display: block;
    width: 100%;
    position: relative;
    max-width: 1120px;
    margin: 20px auto 30px;

    h4,
    h5 {
      margin: 0;
    }

    .info-card {
      justify-content: space-around;
      flex-direction: row;
      align-items: center;
      display: flex;
      background-color: #fbfbfb;
      padding: 16px 14px;
      border: 0.5px solid #d6d9d9;
      border-radius: 8px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 8px;

      .info-left {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .info-icon {
          width: 60px;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: white;
          border: 5px solid #d6d9d9;
          border-radius: 50%;

          i {
            font-size: 26px;
            color: #268ea6;
          }
        }

        .info-header-text {
          width: calc(~"100% - 100px");
          padding-left: 20px;

          .info-info {
            margin: 0px;
            margin-top: 4px;

            span {
              color: #505763;
              font-size: 14px;
            }
          }
        }

        .info-title {
          line-height: 25px;

          p {
            text-overflow: ellipsis;
            max-width: 100% !important;
            white-space: nowrap;
            overflow: hidden;
            margin: 0px;
            display: block;
            color: #292f3b;
            font-weight: 600;
            font-size: 18px;
          }
        }
      }

      .info-right {
        .activation-bar {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
          position: relative;
          min-width: 300px;
          margin: 0 auto;

          input {
            width: 100%;
            border-radius: 8px;
            outline: none;
            padding: 8px 12px;
            box-sizing: border-box;
            border: 0.5px solid #d6d9d9;
            background: #ffffff;
            height: 54px;
            font-size: 18px;
            font-weight: 700;
            font-family: "Roboto";
            color: #292f3b;
          }

          button {
            position: absolute;
            box-shadow: unset;
            border-radius: 8px;
            height: 100%;
            margin: 0px;
            right: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            padding: 0px 12px;
            font-weight: 500;
            letter-spacing: 0.2px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .attended-events-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    margin: 0px;
  }
}

@media (max-width: 768px) {
  #attended-events {
    .activation-block {
      .info-card {
        flex-direction: column;

        .info-left {
          flex-direction: column;

          .info-icon {
            margin-bottom: 12px;
          }

          .info-header-text {
            padding-left: 0px;
            margin: 0px;
            text-align: center;
            width: 100%;
          }
        }

        .info-right {
          margin-top: 16px;
          width: 100%;
        }
      }
    }

    .attended-events-container {
      grid-template-columns: 1fr !important;
    }
  }
}

@media (max-width: 354px) {
  #attended-events {
    .activation-block {
      .info-card {
        flex-direction: column;

        .info-left {
          flex-direction: column;

          .info-icon {
            margin-bottom: 12px;
          }

          .info-header-text {
            padding-left: 0px;
            margin: 0px;
            text-align: center;
            width: 100%;
          }
        }

        .info-right {
          margin-top: 16px;
          width: 100%;

          .activation-bar {
            flex-direction: column;
            max-width: 100%;
            width: 100%;
            min-width: unset;

            input {
              max-width: 100%;
              text-align: center;
            }

            button {
              position: relative;
              display: block;
              border-radius: 8px;
              margin-top: 10px;
              padding: 16px 30px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AttendedEvents.vue